// @ts-nocheck
const GTM_ID = "GTM-NKRXJ22";

export const loadGTM = () => {
    if (document.getElementById("gtm-script")) return;

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    script.async = true;
    document.head.appendChild(script);

    //console.log("[GTM Loaded]");
    };

    /**
     * Call this to set consent to disallow selling/sharing info
     * Optionally disable analytics as well.
     */
    export const disallowSharingInfo = ({ analytics = true } = {}) => {
    const consent = {
        ad_storage: "denied", // ❌ no ad tracking or sharing
        analytics_storage: analytics ? "granted" : "denied",
        functionality_storage: "granted",
    };

    // Save to localStorage
    localStorage.setItem(
        "cookie_consent",
        JSON.stringify({
        marketing: false,
        analytics,
        })
    );

    // Push to GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "default_consent", consent });
    window.dataLayer.push({ event: "update_consent", consent });

    const shouldLoad =
        (consent.analytics_storage === "granted" || consent.ad_storage === "granted") &&
        !document.getElementById("gtm-script");

    if (shouldLoad) {
        loadGTM();
    } else {
       // console.log("[GTM Not Loaded] - Consent denied or already loaded");
    }
};
